import { Routes } from '@angular/router';
import { PortfolioProjectListComponent } from './portfolio-project-list/portfolio-project-list.component';
import { HomeComponent } from './home/home.component';
import { FavoritesComponent } from './favorites/favorites.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ProjectComponent } from './project/project.component';
import { LoginComponent } from './login/login.component';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { AdminProjectListComponent } from './admin-project-list/admin-project-list.component';
import { AdminProjectFormComponent } from './admin-project-form/admin-project-form.component';
import { hiddenProjectGuard } from './guards/hidden-project.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'portfolio', component: PortfolioProjectListComponent },
  { path: 'favorites', component: FavoritesComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'projects/:id', component: ProjectComponent, canActivate: [hiddenProjectGuard] },
  { path: 'access', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'admin/projects', component: AdminProjectListComponent, canActivate: [authGuard, adminGuard] },
  { path: 'admin/projects/new', component: AdminProjectFormComponent, canActivate: [authGuard, adminGuard] },
  { path: 'admin/projects/:id/edit', component: AdminProjectFormComponent, canActivate: [authGuard, adminGuard] }
];
